/**
 * 页面样式配置
 */
import { CSSProperties } from "react";

// 列表项样式配置
export const listItemStyles = {
  base: {
    padding: "12px 16px",
    borderRadius: "6px",
    marginBottom: "8px",
    cursor: "pointer",
    transition: "all 0.2s",
  } as CSSProperties,
  selected: {
    border: "2px solid #1890ff",
    backgroundColor: "#f6ffed",
  } as CSSProperties,
  unselected: {
    border: "1px solid #f0f0f0",
    backgroundColor: "#fff",
  } as CSSProperties,
};

// 列表容器样式
export const listContainerStyles = {
  height: "calc(100vh - 160px)",
  overflow: "auto",
  scrollbarWidth: "thin",
  scrollbarColor: "#d9d9d9 #f0f0f0",
} as CSSProperties;

// 空状态样式
export const emptyStateStyles = {
  textAlign: "center",
  padding: "40px 0",
  color: "#999",
} as CSSProperties;

// 卡片样式
export const cardStyles = {
  height: "100vh",
  borderBottom: "1px solid #f0f0f0",
} as CSSProperties;

// 权限数量标签样式
export const permissionCountLabelStyles = {
  fontSize: "12px",
  color: "#666",
  marginBottom: "4px",
} as CSSProperties;

export const permissionCountValueStyles = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#1890ff",
} as CSSProperties;

// 角色名称样式
export const roleNameStyles = {
  fontWeight: 500,
  marginBottom: "4px",
} as CSSProperties;

export const roleCodeStyles = {
  fontSize: "12px",
  color: "#666",
} as CSSProperties;

